import React from "react";
import { Link } from "react-router-dom";
import { FaRocket, FaShieldAlt, FaUsers } from "react-icons/fa";

const About = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-20 space-y-12">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-500">
          About All Stream Downloader
        </h1>
        <p className="text-gray-400 text-lg">
          The ultimate tool for archiving your favorite media.
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-3">
        <div className="bg-white/5 p-6 rounded-2xl border border-white/10 text-center">
          <FaRocket className="text-3xl text-cyan-400 mx-auto mb-4" />
          <h3 className="text-xl font-bold mb-2">Fast & Reliable</h3>
          <p className="text-gray-400 text-sm">We utilize high-speed servers to ensure your downloads are processed quickly without buffering.</p>
        </div>
        <div className="bg-white/5 p-6 rounded-2xl border border-white/10 text-center">
          <FaShieldAlt className="text-3xl text-green-400 mx-auto mb-4" />
          <h3 className="text-xl font-bold mb-2">Secure</h3>
          <p className="text-gray-400 text-sm">We do not store your personal data or downloaded files on our servers permanently. Your privacy matters.</p>
        </div>
        <div className="bg-white/5 p-6 rounded-2xl border border-white/10 text-center">
          <FaUsers className="text-3xl text-purple-400 mx-auto mb-4" />
          <h3 className="text-xl font-bold mb-2">User Focused</h3>
          <p className="text-gray-400 text-sm">Designed with simplicity in mind. No ads, no pop-ups, just a clean downloading experience.</p>
        </div>
      </div>

      <div className="prose prose-invert max-w-none text-gray-300 bg-black/20 p-8 rounded-2xl">
        <h3 className="text-white">Our Mission</h3>
        <p>
          In an age of streaming, we believe users should have the right to archive content they have legitimate access to for offline viewing. 
          All Stream Downloader was created to bridge the gap between streaming convenience and offline accessibility.
        </p>
        <p>
          We support a wide range of platforms to make your life easier, whether you are a content creator backing up your own work, 
          a researcher archiving public information, or a casual user saving a tutorial for a flight.
        </p>
      </div>
    </div>
  );
};

export default About;